import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';

import Label from 'core/components/label/label';
import useStyles from './aor-run-detail.styles';

/** One member row of an apply report: the P5 branch's `details` (#33091). */
const MemberResultRow = ({ details, error, showError }) => {
  const classes = useStyles();
  // A snapshot row with no accountId still reports here. `''` is not nullish, so guard on truthiness
  // or the cell renders an empty label linking at `/customer/`; fall back to the email, which is the
  // only other identifier such a row carries.
  const accountId = details.accountId || '';

  return (
    <TableRow>
      <TableCell>
        {accountId ? (
          <Link to={`/customer/${accountId}`} target="_blank" rel="noopener noreferrer">
            <Label type="action" className={classes.tableLink}>
              {accountId}
            </Label>
          </Link>
        ) : (
          details.email || '—'
        )}
      </TableCell>
      <TableCell>{details.oldAffinity || '—'}</TableCell>
      <TableCell>{details.newAffinity || '—'}</TableCell>
      <TableCell>{details.memberOutcome ?? '—'}</TableCell>
      {showError && <TableCell className={classes.errorCell}>{error ?? '—'}</TableCell>}
    </TableRow>
  );
};

MemberResultRow.propTypes = {
  details: PropTypes.object.isRequired,
  error: PropTypes.string,
  showError: PropTypes.bool
};

MemberResultRow.defaultProps = {
  error: null,
  showError: false
};

export const memberResultVariant = {
  key: 'members',
  label: 'members',
  columns: ['Account', 'From', 'To', 'Member affinity'],
  rowKey: (details) => details.accountId,
  // `memberOutcome`, not `accountId`: policy rows carry an accountId too, so matching on that would
  // swallow them. Key presence, not truthiness — the worker sets the outcome on EVERY row it emits,
  // including the row for a snapshot entry that had no accountId to read, so every member failure
  // reaches this table rather than the policy fallback.
  matches: (details) => 'memberOutcome' in details,
  Row: MemberResultRow
};

export default MemberResultRow;
